{
  "name": "@hufe921/canvas-editor",
  "author": "Hufe",
  "license": "MIT",
  "version": "0.9.135",
  "description": "A Canvas/SVG-based rich text editor",
  "publishConfig": {
    "registry": "https://registry.npmjs.org/",
    "access": "public"
  },
  "files": [
    "dist",
    "README.md",
    "CHANGELOG.md",
    "LICENSE",
    "package.json"
  ],
  "typings": "./dist/src/editor/index.d.ts",
  "main": "./dist/canvas-editor.umd.cjs",
  "module": "./dist/canvas-editor.js",
  "homepage": "https://github.com/Hufe921/canvas-editor",
  "repository": {
    "type": "git",
    "url": "https://github.com/Hufe921/canvas-editor.git"
  },
  "keywords": [
    "canvas-editor",
    "editor",
    "wysiwyg",
    "emr"
  ],
  "engines": {
    "node": ">=24.13.1"
  },
  "type": "module",
  "scripts": {
    "dev": "vite",
    "lib": "eslint . && tsc && vitest run && vite build --mode lib",
    "build": "eslint . && tsc && vitest run && vite build --mode app",
    "serve": "vite preview",
    "lint": "eslint . && tsc --noEmit && vitest run",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "test:unit": "vitest run",
    "test:unit:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "type:check": "tsc --noEmit",
    "docs:dev": "vitepress dev docs",
    "docs:build": "vitepress build docs",
    "docs:preview": "vitepress preview docs",
    "postinstall": "simple-git-hooks",
    "pre-release": "node scripts/pre-release.js"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@rollup/plugin-typescript": "^12.3.0",
    "@types/jsdom": "^28.0.3",
    "@types/node": "^24.12.4",
    "@types/prismjs": "^1.26.6",
    "@typescript-eslint/eslint-plugin": "^8.59.3",
    "@typescript-eslint/parser": "^8.59.3",
    "@vitest/coverage-v8": "^4.1.6",
    "cypress": "^15.15.0",
    "cypress-file-upload": "^5.0.8",
    "eslint": "^10.4.0",
    "globals": "^17.6.0",
    "jsdom": "^29.1.1",
    "simple-git-hooks": "^2.13.1",
    "tslib": "^2.8.1",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.59.3",
    "vite": "^8.0.13",
    "vite-plugin-css-injected-by-js": "^5.0.1",
    "vitepress": "^1.6.4",
    "vitest": "^4.1.6",
    "vitest-canvas-mock": "^1.1.4",
    "vue": "^3.5.34"
  },
  "dependencies": {
    "prismjs": "^1.27.0"
  },
  "simple-git-hooks": {
    "pre-commit": "npm run lint && npm run type:check",
    "commit-msg": "node scripts/verifyCommit.js"
  }
}
